import { render, staticRenderFns } from "./conf.vue?vue&type=template&id=47791808&scoped=true&"
import script from "./conf.vue?vue&type=script&lang=js&"
export * from "./conf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47791808",
  null
  
)

export default component.exports